import React from "react";
import { IoInformationCircleOutline } from "react-icons/io5";

import { siteConfig } from "../../constants";
import * as Styled from "./index.styled";

interface Props {
  openInfoPopUp: () => void;
}

export function Header({ openInfoPopUp }: Props) {
  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.InfoButton
          aria-label="Open game instructions"
          onClick={openInfoPopUp}
          type="button"
        >
          <IoInformationCircleOutline size={30} width={30} height={30} />
        </Styled.InfoButton>

        <Styled.Logo>{siteConfig.name}</Styled.Logo>
        <span aria-hidden="true" />
      </Styled.Content>
    </Styled.Container>
  );
}
